export const THEME_CONFIG = {
  mobileNav: false,
  locale: sessionStorage.getItem('lang') === 'ja' ? 'ja' : 'en',
  balanceOAS: localStorage.getItem('balanceOAS') || 0,
  user: localStorage.getItem('user')
    ? JSON.parse(localStorage.getItem('user'))
    : null,
}
